(() => {
  const root = document.querySelector('[data-hero-slider]');
  if (!root) return;
  const slides = [...root.querySelectorAll('[data-hero-slide]')];
  const dots = [...root.querySelectorAll('[data-hero-dot]')];
  const track = root.querySelector('[data-hero-track]');
  const toggle = root.querySelector('[data-hero-toggle]');
  let index = 0;
  let timer;
  let paused = false;
  let pointerStart = null;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function show(next, focus = false) {
    index = (next + slides.length) % slides.length;
    track.style.transform = `translate3d(-${index * 100}%,0,0)`;
    slides.forEach((slide, i) => { slide.toggleAttribute('inert', i !== index); slide.setAttribute('aria-hidden', String(i !== index)); });
    dots.forEach((dot, i) => { dot.setAttribute('aria-selected', String(i === index)); dot.tabIndex = i === index ? 0 : -1; });
    if (focus) dots[index].focus();
  }
  function autoplay() { clearInterval(timer); if (!reduced && !paused && slides.length > 1) timer = setInterval(() => show(index + 1), 6500); }
  root.querySelector('[data-hero-prev]')?.addEventListener('click', () => { show(index - 1); autoplay(); });
  root.querySelector('[data-hero-next]')?.addEventListener('click', () => { show(index + 1); autoplay(); });
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => { show(i); autoplay(); });
    dot.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); show(index + (e.key === 'ArrowRight' ? 1 : -1), true); } });
  });
  toggle?.addEventListener('click', () => {
    paused = !paused;
    toggle.setAttribute('aria-pressed', String(paused));
    toggle.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
    toggle.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
    autoplay();
  });
  root.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') pointerStart = e.clientX; });
  root.addEventListener('pointerup', e => {
    if (pointerStart === null) return;
    const distance = e.clientX - pointerStart;
    pointerStart = null;
    if (Math.abs(distance) < 45) return;
    show(index + (distance < 0 ? 1 : -1));
    autoplay();
  });
  root.addEventListener('pointercancel', () => { pointerStart = null; });
  root.addEventListener('pointerenter', () => clearInterval(timer));
  root.addEventListener('pointerleave', autoplay);
  root.addEventListener('focusin', () => clearInterval(timer));
  root.addEventListener('focusout', autoplay);
  document.addEventListener('visibilitychange', () => document.hidden ? clearInterval(timer) : autoplay());
  show(0); autoplay();
})();
